<script lang="ts">
    import cx from 'classnames';
    import RedDot from '../Badge/RedDot.svelte';
    export let selected = false;
    export let text = '';
    export let href: string | null = null;
    export let onClick: (() => void) | undefined = undefined;
    export let testid: string;
    export let hasNotification: boolean = false;

    const componentTag = onClick ? 'div' : 'a';
    const linkProps = onClick
        ? {}
        : {
              href
          };
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<svelte:element
    this={componentTag}
    on:click={onClick}
    {...linkProps}
    data-testid={testid}
    class={cx(
        'relative cursor-pointer select-none transition-all duration-[100ms]',
        'active:shadow-none shadow-2 active:translate-y-[2px] active:duration-[10ms]',
        'px-2xs pb-[7px] pt-[6px] tablet:px-xs tablet:py-[10px]',
        'rounded-[12px] border-b-[3px] border-b-[rgba(19,0,49,0.20)] tablet:border-b-[4px]',
        {
            'bg-white': selected,
            'bg-purple-60 ': !selected
        }
    )}
>
    <div class="fill-current flex items-center gap-3xs">
        <span
            class={cx('flex size-md items-center justify-center', {
                'text-purple-60': selected,
                'text-white': !selected
            })}
        >
            <slot name="icon" />
        </span>
        {#if text}
            <span
                class={cx(
                    'inline-block min-w-0 whitespace-nowrap text-sm font-bold tablet:text-base',
                    {
                        'text-purple-80': selected,
                        'text-white': !selected
                    }
                )}
            >
                {text}
            </span>
        {/if}
    </div>
    {#if hasNotification}
        <RedDot />
    {/if}
</svelte:element>
